import styled from 'styled-components';
import { RegularButton, OutlinedButton } from 'pg-ui-library';

export const AvailableBenefitsCardContainer = styled.div`
  display: flex;
  width: 441px;
  border-radius: 4px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
`;

type ImgContainerProps = {
  editMode: boolean;
};

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const CardImgContainer = styled.div<ImgContainerProps>`
  display: flex;
  flex-grow: 2;
  background-position: center;
  width: 116px;
  height: 116px;
  height: ${props => (props.editMode ? '150px' : '"116px"')};
  border-radius: 10px;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-right: 16px;
  padding-left: 15px;
  background: transparent linear-gradient(180deg, #ffffff 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
  border-radius: 4px;
`;

export const CardContentTitle = styled.p`
  font-size: 18px;
  color: #1c1b3a;
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 10px;
`;

export const CardContentDate = styled.p`
  margin: 0;
  font-size: 16px;
  color: #1c1b3a;
  font-weight: 600;
`;

export const SeparatorLine = styled.div`
  content: '';
  flex: 1;
  height: 1px;
  background-color: #222247;
  align-self: center;
`;

export const CardContentFee = styled.p`
  margin-top: 10px;
  font-size: 18px;
  color: #1c1b3a;
  font-weight: 600;
`;

export const SpanContent = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #222247;
`;

export const NegativeSpanContent = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: red;
  text-decoration: line-through;
`;

export const ImgContentContainer = styled.div`
  padding: 3px;
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonIcon = styled.img`
  height: auto;
  margin-left: 5px;
  color: red;
`;

export const EditButton = styled(RegularButton)`
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  min-width: 90px;
  margin-right: 0;
`;

export const RemoveButton = styled(OutlinedButton)`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  color: #d50b30;
  border-color: #d50b30;
  min-width: 90px;
  margin-right: 0;
  &:hover {
    cursor: pointer;
    transition: 0.75s;
    color: #d50b30;
    border-color: #d50b30;
    min-width: 90px;
    margin-right: 0;
    background-color: transparent;
  }
`;

export const MandatoryContainer = styled.div`
  align-self: flex-end;
  width: 10%;
  height: 30px;
  background: #ffba00;
  color: white;
  margin-top: 1%;
  margin-right: -3%;
  border-radius: 50px;
  text-align: right;
`;

export const MandatoryToolTip = styled.div`
  position: sticky;
  z-index: 200;
  width: 300px;
  margin-left: -255px;
  margin-top: 0.5%;
  background: white;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.3);
`;

export const MandatoryIcon = styled.img`
  margin-bottom: -17%;
  margin-right: 31%;
`;

export const MandatoryToolTipText = styled.p`
  text-align: left;
  color: black;
  font-size: 10pt;
  padding: 5px;
`;
